import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
const SvgEdit = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 18 19",
	...props,
	children: /* @__PURE__ */ _jsxs("g", { children: [/* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M13.313 6L10.5 3.187l-7.5 7.5V13.5h2.813l7.5-7.5zm2.22-2.22a.747.747 0 0 0 0-1.057L13.777.968a.747.747 0 0 0-1.058 0l-1.47 1.47 2.813 2.812 1.47-1.47z"
	}), /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		d: "M0 15.75h18v3H0z"
	})] })
});
export default SvgEdit;
